// Stylesheets
import './assets/scss/site.scss';

import { externalLink } from './assets/modules/externalLink';
import { trigger } from './assets/modules/trigger';
import { popup } from './assets/modules/popup';
import { copyUrl } from './assets/modules/copyUrl';
import { hover } from './assets/modules/hover';
import { setHeight } from './assets/modules/setHeight';
import { scatteredCards } from './assets/modules/scatteredCard';
import { fluidEmbed } from './assets/modules/fluidEmbed';
import { filterLibrary } from './assets/modules/filterLibrary';
import { initPhotoSwipeFromDOM } from './assets/modules/photoswipe';
import { stickySidebar } from './assets/modules/stickySidebar';
import { flyEmoji } from './assets/modules/flyEmoji';
import { equalHeight } from './assets/modules/equalHeight';
import { word404 } from './assets/modules/word404';
import { formSelect } from './assets/modules/form';

const init = () => {
  externalLink();
  trigger();
  popup();
  copyUrl();
  hover();
  setHeight();
  scatteredCards();
  fluidEmbed();
  filterLibrary();
  initPhotoSwipeFromDOM('.js-pswp-container');
  stickySidebar();
  flyEmoji();
  equalHeight();
  word404();
  formSelect();
  document.body.classList.add('is-init');
}

init();